module.exports = __webpack_public_path__ + "static/img/board_b21.9c931e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/board_b21.jpg
// module id = nFYo
// module chunks = 0